import React from 'react';
import { SkText } from '../../components/SkeletonLoader/SkeletonLoader';
import styles from './ProdutosPageSkeleton.module.css';

// Columns: Produto, Linha, Faturamento, Qtd, Margem, Preço Médio, Nº Clientes
const COL_WIDTHS = [200, 100, 130, 85, 80, 100, 70];

const TableRowSk: React.FC = () => (
  <div className={styles.row}>
    {COL_WIDTHS.map((w, i) => (
      <SkText key={i} width={w} height={14} style={{ flexShrink: 0 }} />
    ))}
  </div>
);

const ProdutosPageSkeleton: React.FC = () => (
  <div style={{ width: '100%', minHeight: '700px' }}>
    {/* 15 skeleton rows to match ITEMS_PER_PAGE */}
    {Array.from({ length: 15 }).map((_, i) => <TableRowSk key={i} />)}
  </div>
);

export default ProdutosPageSkeleton;
